import React from 'react';
import useStepNavigator from '@fnol/library/src/hooks/useStepNavigator';

type EnhancedRouteProps = {
    index: number;
    steps: { path: string; screen: Function }[];
    Element: Function;
    skipSteps: number[];
};

const EnhancedRoute = (props: EnhancedRouteProps) => {
    const { Element, index, steps, skipSteps} = props;

    const navigator = useStepNavigator(steps, index, skipSteps);

    return <Element navigator={navigator} />;
};

export default EnhancedRoute;
